import { http } from '../request'
import { expectArrayData } from './shared'

export interface SemesterDto {
  id: number
  academicYearId: number
  academicYearName?: string | null
  name: string
  typeId?: number | null
  typeName?: string | null
  startDate: string
  endDate: string
  isCurrent?: boolean | null
  sort?: number
}

/** 当前学期判定状态（2026-11-05 学年学期页诊断状态条） */
export interface CurrentSemesterStatusDto {
  resolved: boolean
  /** MANUAL=人工标记；AUTO=按日期推导；未判定为 null */
  mode?: 'MANUAL' | 'AUTO' | null
  semesterId?: number | null
  semesterName?: string | null
  /** 学校是否建过学期（判定失败时区分引导方向） */
  anySemester: boolean
}

interface CreateSemesterRequest {
  academicYearId: number
  typeId: number
  startDate: string
  endDate: string
  sort?: number
}

interface UpdateSemesterRequest {
  typeId?: number
  startDate?: string
  endDate?: string
  sort?: number
}

export const semesterApi = {
  async list(academicYearId?: number): Promise<SemesterDto[]> {
    const response = await http.get<SemesterDto[]>('/academic/semesters', { academicYearId })
    return expectArrayData<SemesterDto>(response.data, '/academic/semesters')
  },

  async create(payload: CreateSemesterRequest): Promise<SemesterDto> {
    const response = await http.post<SemesterDto>('/academic/semesters', payload)
    return response.data
  },

  async update(id: number, payload: UpdateSemesterRequest): Promise<SemesterDto> {
    const response = await http.put<SemesterDto>(`/academic/semesters/${id}`, payload)
    return response.data
  },

  async remove(id: number): Promise<void> {
    await http.delete(`/academic/semesters/${id}`)
  },

  async setCurrent(id: number, force = false): Promise<SemesterDto> {
    const response = await http.put<SemesterDto>(`/academic/semesters/${id}/set-current?force=${String(force)}`)
    return response.data
  },

  async currentStatus(): Promise<CurrentSemesterStatusDto> {
    const response = await http.get<CurrentSemesterStatusDto>('/academic/semesters/current-status')
    return response.data
  }
}
